import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import LandingUseCasesHelmet from 'common/helmets/LandingUseCasesHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import UseCases7 from 'img/landing/ads-landing-pages.webp';
import UseCases1 from 'img/landing/use-cases-1.webp';
import UseCases2 from 'img/landing/use-cases-2.webp';
import UseCases3 from 'img/landing/use-cases-3.webp';
import UseCases4 from 'img/landing/use-cases-4.webp';
import UseCases5 from 'img/landing/use-cases-5.webp';
import UseCases6 from 'img/landing/use-cases-6.webp';

import 'css/components/www/_LandingDirectory.scss';

class LandingUseCases extends Component {
  render() {
    return (
      <div className="landingDirectory">
        <LandingUseCasesHelmet />
        <div className="landingDirectoryContainer">
          <div className="header">
            <div className="left">
              <div className="text">
                <h1 className="title">Canny Use Cases</h1>
                <div className="subtitle">
                  The several different ways Canny can benefit your&nbsp;business
                </div>
              </div>
            </div>
          </div>
          <div className="directoryGrid">
            <Link className="directoryItem" to="/use-cases/feature-request-management">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases1} />
                <div className="text">
                  <div className="title">Feature request management</div>
                  <div className="description">
                    Canny helps you keep all all feature requests in one organized place. No more
                    feedback scattered across spreadsheets and conversations.
                  </div>
                </div>
              </div>
            </Link>
            <Link className="directoryItem" to="/use-cases/idea-management">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases2} />
                <div className="text">
                  <div className="title">Idea management</div>
                  <div className="description">
                    Use Canny to streamline your idea management process to extract insights and
                    build better products.
                  </div>
                </div>
              </div>
            </Link>
            <Link className="directoryItem" to="/use-cases/internal-feedback">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases3} />
                <div className="text">
                  <div className="title">Internal feedback</div>
                  <div className="description">
                    Canny isn’t just for feedback from customers. Make it your team's single hub for
                    feedback across the company.
                  </div>
                </div>
              </div>
            </Link>
            <Link className="directoryItem" to="/use-cases/product-management">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases4} />
                <div className="text">
                  <div className="title">Product management</div>
                  <div className="description">
                    Canny is built to collect, organize, and utilize feedback. With that data,
                    product managers can feel empowered to make the most impactful product
                    decisions.
                  </div>
                </div>
              </div>
            </Link>
            <Link className="directoryItem" to="/use-cases/sales">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases5} />
                <div className="text">
                  <div className="title">Sales</div>
                  <div className="description">
                    For sales, Canny is there to amplify your voice, whether it’s by influencing
                    product decisions or enhancing your team’s sales processes.
                  </div>
                </div>
              </div>
            </Link>
            <Link className="directoryItem" to="/use-cases/public-roadmap">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases6} />
                <div className="text">
                  <div className="title">Public roadmap</div>
                  <div className="description">
                    Make your roadmap public to show off what your team is working on and collect
                    valuable feedback.
                  </div>
                </div>
              </div>
            </Link>
            <Link className="directoryItem" to="/use-cases/customer-feedback">
              <div className="directoryItemContents">
                <LazyLoadedImage loading="eager" src={UseCases7} />
                <div className="text">
                  <div className="title">Customer feedback</div>
                  <div className="description">
                    Capture, organize, and prioritize all your feedback. Build the features that
                    matter most.
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <LandingFooterCTA style="solid" expanded={true} />
        </div>
      </div>
    );
  }
}

export default hot(LandingUseCases);
